import { CloseButton } from '@repo/ui'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'

type ItemCloseButtonProps = Readonly<{
  className?: string
  onClick: () => void
}>

export function ItemCloseButton({ className, onClick }: ItemCloseButtonProps) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  return (
    <CloseButton
      className={className}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onClick()
      }}
      size="sm"
      title={t('Remove bonus')}
      variant="default"
    />
  )
}